import axios, { AxiosResponse } from 'axios';
import {
  IWPLinkRequest,
  ILMSIntegrationResponse,
  IIntegrationItem,
  IAddLMSLinkRequest,
  IAddLMSLinkResponse,
  IGetLinksByCourseResponse,
  IExportToPublishRequest,
  IExportToPublishResponse,
  IGetPublishLogsByCourseResponse,
  IMentorkitLMSLinkRequest,
  ISynthesiaLinkRequest,
  ILMSUpdateLinkItem,
} from '../models/LMSLinkModel';
import { accessToken } from './agent';
import { IMentorkitLMSCourseList } from '../../store/publishStore';

export const axiosIntegration = axios.create({
  baseURL: process.env.REACT_APP_ENV_API && process.env.REACT_APP_ENV_API.trim() !== '' ? process.env.REACT_APP_ENV_API + '/userAPI/' : 'https://niastest02.norskinteraktiv.no/userAPI/',
  // baseURL: 'https://localhost:5001/',
});

axiosIntegration.interceptors.request.use(
  function (config) {
    config.headers.authorization = `Bearer ${accessToken}`;
    return config;
  },
  function (error) {
    console.log(error);
    return Promise.reject(error);
  },
);

const responseBody = <T>(response: AxiosResponse<T>) => response.data;

const requests = {
  get: <T>(url: string) => axiosIntegration.get<T>(url).then(responseBody),
  post: <T>(url: string, body: any) =>
    axiosIntegration
      .post<T>(url, body, {
        headers: {
          'Content-Type': 'application/json-patch+json',
        },
      })
      .then(responseBody),
  delete: <T>(url: string) => axiosIntegration.delete<T>(url).then(responseBody),
};
const CourseLMSLink = {
  AddLMSIntegration: (data: IWPLinkRequest | IMentorkitLMSLinkRequest | ISynthesiaLinkRequest) => requests.post<ILMSIntegrationResponse>('/CourseLMSLink/AddLMSIntegration', data),
  addWPLink: (data: IWPLinkRequest) => requests.post<ILMSIntegrationResponse>('/CourseLMSLink/AddWPLink', data),
  addLMSLink: (data: IAddLMSLinkRequest) => requests.post<IAddLMSLinkResponse>('/CourseLMSLink/AddLMSLink', data),
  updateLMSLink: (data: ILMSUpdateLinkItem) => requests.post<IAddLMSLinkResponse>('/CourseLMSLink/UpdateLMSLink', data),
  getLinksByCourse: (creatorCourseId: number) => requests.get<IGetLinksByCourseResponse>(`/CourseLMSLink/ByCourse/${creatorCourseId}`),
  deleteCourseLink: (lmsCustomerId: number, creatorCourseId: number) => requests.delete(`/CourseLMSLink/DeleteCourseLink/${lmsCustomerId}/${creatorCourseId}`),
  deleteLMSLink: (lmsCustomerId: number, aOwnerID: number) => requests.delete(`/CourseLMSLink/DeleteLink/${lmsCustomerId}/${aOwnerID}`),
  exportToPublish: (courseId: number, version: string, language: string, collectAllFiles: boolean, lmsCustomerId?: number, coverImageUrl?: string) => {
    const body: IExportToPublishRequest = {
      courseId,
      version,
      language,
      collectAllFiles,
      customerLmsLinkId: lmsCustomerId ?? null,
      coverImageUrl: typeof coverImageUrl === 'string' && coverImageUrl.trim() !== '' ? encodeURI(coverImageUrl) : null,
    };
    return requests.post<IExportToPublishResponse>('/CourseLMSLink/ExportStaticHtml/ExportToPublish', body);
  },
  getPublishLogsByCourse: (creatorCourseId: number) => requests.get<IGetPublishLogsByCourseResponse>(`/CourseLMSLink/LogsByCourse/${creatorCourseId}`),
};

const WPLink = {
  getWPLinks: (creatorOwnerId: number) => requests.get<IIntegrationItem[]>(`/WPLink/GetWPLinks/${creatorOwnerId}`),
  deleteWPLink: (lmsCustomerId: number) => requests.delete(`/WPLink/DeleteWPLink/${lmsCustomerId}`),
};

const MentorkitLms = {
  GetCourseList: (lmsCustomerId: number) => requests.get<IMentorkitLMSCourseList[]>(`/MentorkitLMS/GetCourseList/${lmsCustomerId}`),
};

const agent = {
  CourseLMSLink,
  WPLink,
  MentorkitLms,
};

export default agent;
